// WEXHUB: texto a insertar para abrir el menu de respuestas predefinidas desde un boton.
// El editor solo abre el menu si "/" esta al inicio del mensaje o despues de un espacio,
// asi que se antepone un espacio cuando el mensaje termina pegado a texto.
export const getCannedResponseTrigger = (message = '') =>
  message && !/\s$/.test(message) ? ' /' : '/';
